// Shared across every place that decides whether a signed-in user is CU-2
// platform staff (routes to /credit-unions instead of /dashboard, sees the
// platform top bar, etc.) — was six independent copies of the same string
// check across App.tsx, Login.tsx, AuthCallback.tsx, CreditUnions.tsx, and
// InviteAccept.tsx. One canonical copy means they can't drift apart again.
// Mirrors src/api/auth/platform-email.ts on the backend.
const PLATFORM_EMAIL_SUFFIXES = ['@cu-2.com', '@jasperdrake.com'];

export function isPlatformEmail(email?: string | null): boolean {
  if (!email) return false;
  const lower = email.toLowerCase();
  return PLATFORM_EMAIL_SUFFIXES.some((suffix) => lower.endsWith(suffix));
}
